import * as React from 'react';
import Modal from '../../ui/modal/Modal';
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Attachment from "../../../model/attachment/Attachment";
import SectionSeparator from "../../layout/section/SectionSeparator";

interface Props {
	attachments: Attachment[]
	hideModal: () => void;
	removeFiles: (ids: string[]) => void
}

interface State {
	selectedFiles: { [key: string]: boolean }
}

export default class RemoveFilesConfirmation extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			selectedFiles: {}
		};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.hideModal}
				   title={"Remove files"}
				   mediumWidth>
				{this.props.attachments.length == 1 ?
					this.renderRemoveOneFileConfirmation(this.props.attachments[0])
					: this.renderSeveralFilesConfirmation(this.props.attachments)}
			</Modal>
		)
	}

	renderRemoveOneFileConfirmation = (att: Attachment) => {
		return (<>
			<span className={"t-body"}>Are you sure you want to delete the file <strong>{att.name}</strong>?</span>
			<SectionSeparator style={{margin: "20px 0"}}/>
			<ButtonTertiary label={"Cancel"} onClick={this.props.hideModal}/>
			<div className={"pull-right"}>
				<ButtonPrimary label={"Remove"} onClick={() => this.props.removeFiles([att.id])}/>
			</div>
		</>)
	}

	renderSeveralFilesConfirmation = (attachments: Attachment[]) => {
		return (
			<>
				<div className={"t-body"} style={{fontSize: "16px", marginBottom: "20px"}}>
					Select the files you want to delete:
				</div>
				{attachments.map(a => <Checkbox checked={this.state.selectedFiles[a.id]}
												label={a.name}
												onChange={(v) => this.onCheckboxChange(v, a.id)}
												styles={{margin: "5px 0"}}/>)}
				<SectionSeparator style={{margin: "20px 0"}}/>
				<ButtonTertiary label={"Cancel"} onClick={this.props.hideModal}/>
				<div className={"pull-right"}>
					<ButtonPrimary label={"Remove"}
								   onClick={() => this.props.removeFiles(Object.keys(this.state.selectedFiles))}
								   disabled={Object.keys(this.state.selectedFiles).length === 0}/>
				</div>
			</>
		)
	}

	onCheckboxChange = (value: boolean, attachmentId: string) => {
		const selectedFiles = {...this.state.selectedFiles}
		if (value) {
			selectedFiles[attachmentId] = true;
		}
		else {
			delete selectedFiles[attachmentId];
		}
		this.setState({selectedFiles})
	}
}